import React from 'react';
import { Star } from 'lucide-react';
import useReviews from '../../hooks/useReviews';

const BrutalistReviews = () => {
  const { items: reviews } = useReviews();
  return (
    <section className="py-24 mt-20 px-6 bg-background text-foreground border-b border-border">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-sans font-bold uppercase mb-16 tracking-tighter">
          Отзывы
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, i) => (
            <div key={i} className="border border-border p-8 hover:bg-card transition-colors overflow-hidden">
              <div className="flex items-center gap-1 mb-6 text-accent">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <p className="font-mono text-sm leading-relaxed mb-8 min-h-[80px] break-words">
                "{review.text}"
              </p>
              <div className="border-t border-border pt-4">
                <div className="font-sans font-bold uppercase">{review.name}</div>
                <div className="font-mono text-xs text-muted-foreground uppercase">{review.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrutalistReviews;
